export default __webpack_public_path__ + "static/media/driver.655018a2.svg";